import { regex } from './common'
const numeric = /^[0-9]*$/

export default value => {
  return regex(value, numeric)
}
